const MARKET_STORAGE_KEY = 'selectedMarket';

// Domain to site slug mapping
const DOMAIN_SITE_MAP: Record<string, string> = {
  'gettested.us': 'gettested-us',
  'www.gettested.us': 'gettested-us',
  'gettested.co.uk': 'gettested-uk',
  'www.gettested.co.uk': 'gettested-uk',
  'gettested.eu': 'gettested-eu',
  'www.gettested.eu': 'gettested-eu',
  'gettested.ca': 'gettested-ca',
  'www.gettested.ca': 'gettested-ca',
  'gettested.com.au': 'gettested-au',
  'www.gettested.com.au': 'gettested-au',
  'gettested.se': 'gettested-se',
  'www.gettested.se': 'gettested-se',
  'gettested.no': 'gettested-no',
  'www.gettested.no': 'gettested-no',
  'gettested.dk': 'gettested-dk',
  'www.gettested.dk': 'gettested-dk',
  'gettested.ch': 'gettested-ch',
  'www.gettested.ch': 'gettested-ch',
};

/**
 * Gets the site slug based on localStorage override or current domain.
 * Priority:
 * 1. localStorage selectedMarket (user's choice via MarketSelector)
 * 2. Domain-based detection (automatic)
 */
export function getSiteSlug(): string {
  // First check localStorage for user's market selection
  if (typeof window !== 'undefined') {
    const storedMarket = localStorage.getItem(MARKET_STORAGE_KEY);
    if (storedMarket) {
      return storedMarket;
    }
    
    // Fall back to domain-based detection
    const hostname = window.location.hostname;
    if (DOMAIN_SITE_MAP[hostname]) {
      return DOMAIN_SITE_MAP[hostname];
    }
  }
  
  // Fallback to environment variable (for localhost/development/preview)
  return import.meta.env.VITE_CMS_SITE_SLUG || 'gettested-us';
}

/**
 * Gets the site slug based purely on domain (no localStorage override)
 */
export function getDomainBasedSlug(): string {
  if (typeof window === 'undefined') {
    return import.meta.env.VITE_CMS_SITE_SLUG || 'gettested-us';
  }
  
  const hostname = window.location.hostname;
  if (DOMAIN_SITE_MAP[hostname]) {
    return DOMAIN_SITE_MAP[hostname];
  }
  
  return import.meta.env.VITE_CMS_SITE_SLUG || 'gettested-us';
}
